import React from 'react'
import Menu from './components/Menu'
import { Route, Switch } from 'react-router-dom'
import RouteHomeIndex from 'routes/home/index'
import FooterHome from './components/FooterHome'
import { LayoutWithStandardHeader as Layout } from 'stylist'

const RouteHome = () => (
  <Layout>
    <Layout.Header homeRoute="/">
      <Menu />
    </Layout.Header>
    <Layout.Main>
      <Switch>
        <Route path="/" component={RouteHomeIndex} exact />
      </Switch>
    </Layout.Main>
    <Layout.Footer dark>
      <FooterHome />
    </Layout.Footer>
  </Layout>
)

export default RouteHome



// WEBPACK FOOTER //
// ./src/routes/home.js